var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":"","z-index":"1000"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"text-right",style:(_vm.style)},[_c('img',{attrs:{"src":require("@/assets/img/share.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }